import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

const PALETTE = ['#2C5591', '#7C3AED', '#0891B2', '#DB2777', '#65A30D', '#0284C7', '#DC2626', '#0F766E'];

function hashName(name: string): number {
  let h = 0;
  for (const c of name) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return h;
}

@Component({
  selector: 'app-avatar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="avatar"
      [style.width.rem]="sizeRem()"
      [style.height.rem]="sizeRem()"
      [style.font-size.rem]="sizeRem() * 0.36"
      [style.background]="background()"
      [attr.aria-label]="name()"
      role="img"
    >
      {{ initials() }}
    </div>
  `,
  styles: `
    :host {
      display: inline-flex;
      flex-shrink: 0;
    }
    .avatar {
      border-radius: 50%;
      color: #fff;
      display: grid;
      place-items: center;
      font-weight: 600;
      letter-spacing: 0.02em;
      user-select: none;
    }
  `,
})
export class AvatarComponent {
  readonly name = input.required<string>();
  readonly size = input<number>(36);

  readonly sizeRem = computed(() => this.size() / 16);

  readonly initials = computed(() => {
    const parts = this.name().trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return parts[0][0].toUpperCase() + parts[parts.length - 1][0].toUpperCase();
  });

  readonly background = computed(() => PALETTE[hashName(this.name()) % PALETTE.length]);
}
